module.exports = __webpack_public_path__ + "static/img/1020.b2ef2df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1020.jpg
// module id = 202
// module chunks = 0